import type { QueryClient } from '@tanstack/react-query';

import { getQueryKey } from './internal/config';

export class FetchGetClustersLoadService {
  private readonly queryClient: QueryClient;

  public constructor(queryClient: QueryClient) {
    this.queryClient = queryClient;
  }

  public cancelQuery(): Promise<void> {
    return this.queryClient.cancelQueries({ queryKey: getQueryKey() });
  }
}
